export default "__VITE_ASSET__DftHiri8__"